import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { getDefaultSettingsRoute } from 'common/permissions/studyPredicates';


const DefaultStudySettingsRouteRedirect = (props) => {
    useEffect(() => {
        const { router, defaultSettingsRoute } = props;
        router.replace(defaultSettingsRoute);
    }, []);
    return (
        <Fragment>
        </Fragment>
    );
};

export default connect((state, props) => {
    const studyId = props.params.id;
    const defaultSettingsRoute = getDefaultSettingsRoute(state, studyId);

    return {
        defaultSettingsRoute
    };
})(DefaultStudySettingsRouteRedirect);